module.exports = __webpack_public_path__ + "static/media/draw.e20ce22f.gif";